import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { VersionStore } from '@/modules/version/model/mixins';
import versionService from '@/services/version';

export function useVersionList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            store: { type: 'number', default: VersionStore.Apple.value },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: versionService.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: versionService.remove,
            onSuccess: () => fetchList()
        }),
        drop: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to drop this item?',
            request: versionService.drop,
            onSuccess: () => fetchList()
        }),
        undrop: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to undrop this item?',
            request: versionService.undrop,
            onSuccess: () => fetchList()
        }),
        activate: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to activate this item?',
            request: versionService.activate,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, query, actions };
}
